(function () {
  'use strict';

  /* Only run on product pages — not collection/home pages */
  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
  if (!isProductPage) return;

  var SIZE_CHART = [
    { size: 'XS', length: '52"', chest: '20"', shoulder: '13.5"', sleeve: '27"' },
    { size: 'S',  length: '54"', chest: '21"', shoulder: '14"',   sleeve: '28"' },
    { size: 'M',  length: '56"', chest: '22"', shoulder: '26"',   sleeve: '30"' },
    { size: 'L',  length: '58"', chest: '23"', shoulder: '28"',   sleeve: '31"' },
    { size: 'XL', length: '60"', chest: '24"', shoulder: '30"',   sleeve: '32"' }
  ];

  function buildEmbeddedChart() {
    if (document.getElementById('sadimChartEmbed')) return null;
    var rows = SIZE_CHART.map(function(r) {
      return '<tr><td>' + r.size + '</td><td>' + r.length + '</td><td>' +
        r.chest + '</td><td>' + r.shoulder + '</td><td>' + r.sleeve + '</td></tr>';
    }).join('');
    var wrap = document.createElement('div');
    wrap.id = 'sadimChartEmbed';
    wrap.className = 'sadim-size-chart-embed';
    wrap.innerHTML =
      '<div class="sadim-chart-header" id="sadimChartHeader">' +
        '<div class="sadim-chart-header-left">' +
          '<span class="sadim-chart-brand">Sadim Designs · سديم</span>' +
          '<span class="sadim-chart-title">Size guide</span>' +
        '</div>' +
        '<span class="sadim-chart-arrow" id="sadimChartArrow">▾</span>' +
      '</div>' +
      '<div class="sadim-chart-body" id="sadimChartBody">' +
        '<div class="sadim-chart-unit">All measurements in inches</div>' +
        '<table class="sadim-chart-table">' +
          '<thead><tr><th></th><th>Length</th><th>Chest</th><th>Shoulder</th><th>Sleeve</th></tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
        '</table>' +
        '<div class="sadim-chart-note">Between sizes? Go one size up. For a precise fit, use Custom Size below.</div>' +
      '</div>';
    var header = wrap.querySelector('#sadimChartHeader');
    var body = wrap.querySelector('#sadimChartBody');
    var arrow = wrap.querySelector('#sadimChartArrow');
    if (header) {
      header.addEventListener('click', function() {
        body.classList.toggle('open');
        arrow.classList.toggle('open');
      });
    }
    return wrap;
  }

  function fixShipping() {
    if (document.querySelector('.sadim-shipping')) return;
    document.querySelectorAll('.product__tax').forEach(function(el) {
      el.style.display = 'none';
    });
    var priceBlock = document.querySelector('[id^="price-"]') ||
                     document.querySelector('.price__container');
    if (priceBlock) {
      var badge = document.createElement('p');
      badge.className = 'sadim-shipping';
      badge.textContent = 'Free shipping across UAE';
      priceBlock.insertAdjacentElement('afterend', badge);
    }
  }

  function insertBlocks() {
    var target = document.querySelector('.product-form__buttons') ||
                 document.querySelector('button[name="add"]');
    if (!target) return;
    var anchor = target.closest('.product-form__buttons') || target;
    if (!document.getElementById('sadimChartEmbed')) {
      var chart = buildEmbeddedChart();
      if (chart) anchor.parentNode.insertBefore(chart, anchor);
    }
  }

  function init() {
    try { fixShipping(); } catch(e) {}
    try { insertBlocks(); } catch(e) {}
  }

  function safeInit() { try { init(); } catch(e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
  document.addEventListener('shopify:section:load', safeInit);
  setTimeout(safeInit, 800);
  setTimeout(safeInit, 2000);

})();